import React from "react";
import routes from "./helpers/routes";
import { Redirect, Route } from "react-router";
import AppWrapper from "./components/AppWrapper";
import { BookingsTable } from "./components/BookingsTable";
import { SuspendsTable } from "./components/SuspendsTable";
import { OpportunitiesTable } from "./components/OpportunitiesTable";
import { SignInForm } from "./components/signin/SignInForm";
import { SkippingsTable } from "./components/SkippingsTable";
import { PlannerStatsPage } from "./components/planner-stats";
import { useIsAuthorized } from "./helpers/useAuthorization";
import useRedirect from "./hooks/useRedirect";
import { PlatformStats } from "./platform-stats";
import { DeadOppsTable } from "./components/DeadOpportunitiesTable";
import { Spinner } from "@blueprintjs/core";
import { useAppMode, useItinMode } from "./store/model-misc";

function MyRoute({ route, Component, protect }) {
  let WrappedComponent;
  if (protect) {
    WrappedComponent = props => {
      const auth = useIsAuthorized(route);
      const doneLoading = !auth.loading;
      const isDefinitelyNotAuthorized = doneLoading && !auth.isAuthorized;
      const isDefinitelyAuthorized = doneLoading && auth.isAuthorized;
      useRedirect(() => isDefinitelyNotAuthorized, routes.signin);
      const appMode = useAppMode();
      const itinMode = useItinMode();
      return isDefinitelyAuthorized ? (
        <AppWrapper>
          {appMode && itinMode ? <Component {...props} /> : <Spinner />}
        </AppWrapper>
      ) : null;
    };
  } else {
    WrappedComponent = props => (
      <AppWrapper>
        <Component {...props} />
      </AppWrapper>
    );
  }
  return <Route exact path={route} component={WrappedComponent} key={route} />;
}

export const AllRoutes = [
  MyRoute({
    route: routes.signin,
    Component: SignInForm,
    protect: false
  }),
  MyRoute({
    route: routes.opportunities,
    Component: OpportunitiesTable,
    protect: true
  }),
  MyRoute({
    route: routes.dead_opps,
    Component: DeadOppsTable,
    protect: true
  }),
  MyRoute({
    route: routes.bookings,
    Component: BookingsTable,
    protect: true
  }),
  MyRoute({
    route: routes.skippings,
    Component: SkippingsTable,
    protect: true
  }),
  MyRoute({
    route: routes.suspends,
    Component: SuspendsTable,
    protect: true
  }),
  MyRoute({
    route: routes.planner_stats,
    Component: PlannerStatsPage,
    protect: true
  }),
  MyRoute({
    route: routes.platform_stats,
    Component: PlatformStats,
    protect: true
  }),
  <Route render={() => <Redirect to={routes.DEFAULT} />} key="default_route" />
];
